function defer(method) {

	if (window.jQuery) {

		method();

	} else {

		setTimeout(function() { defer(method) }, 1000);

	}
}





defer(function () {

	$('.arrow-right-container, .fa-long-arrow-right').click( function() {

		current = $('.active-slider');

		if (current.next('.slider').length == 1) {
			next = current.next('.slider');
		} else {
			next = current.parent().children('.slider').first();
		}

		current.removeClass('active-slider');
		next.addClass('active-slider animated fadeIn');

		$('.slider-number').text('Slide ' + next.attr('data-slide-number') + ' of 3');

		if ( next.attr('data-increase-slider-height') == 1 ) {
			$('.intro').css('height', '500px');
			next.find('.slider-image').css('max-height', '400px');
		} else {
			$('.intro').css('height', '350px');
		}

	});

	$('.arrow-left-container, .fa-long-arrow-left').click( function() {

		current = $('.active-slider');

		if (current.prev('.slider').length == 1) {
			prev = current.prev('.slider');
		} else {
			prev = current.parent().children('.slider').last();
		}

		current.removeClass('active-slider');
		prev.addClass('active-slider animated fadeIn');

		$('.slider-number').text('Slide ' + prev.attr('data-slide-number') + ' of 3');

		if ( prev.attr('data-increase-slider-height') == 1 ) {
			$('.intro').css('height', '500px');
			prev.find('.slider-image').css('max-height', '400px');
		} else {
			$('.intro').css('height', '350px');
		}		
 
	});





	$('.intro *').hover(function() {
		$('.arrow-left-container').addClass('animated tada');
		$('.arrow-right-container').addClass('animated tada');
	});





	var container = document.querySelector('.intro');

	container.addEventListener("touchstart", startTouch, {'passive': true});
	container.addEventListener("touchmove", moveTouch, {'passive': true});

	// Swipe Up / Down / Left / Right
	var initialX = null;
	var initialY = null;

	function startTouch(e) {
		initialX = e.touches[0].clientX;
		initialY = e.touches[0].clientY;
	};

	function moveTouch(e) {

		if (initialX === null) {

			return;

		}

		if (initialY === null) {
			return;
		}

		var currentX = e.touches[0].clientX;
		var currentY = e.touches[0].clientY;

		var diffX = initialX - currentX;
		var diffY = initialY - currentY;

		if (Math.abs(diffX) > Math.abs(diffY)) {

			// sliding horizontally
			if (diffX > 0) {

			// swiped left

			console.log("swiped left");

			current = $('.active-slider');

			if (current.next('.slider').length == 1) {
				next = current.next('.slider');
			} else {
				next = current.parent().children('.slider').first();
			}

			current.removeClass('active-slider');
			next.addClass('active-slider animated fadeIn');

			$('.slider-number').text('Slide ' + next.attr('data-slide-number') + ' of 3');


			} else {

			// swiped right

			console.log("swiped right");

			current = $('.active-slider');

			if (current.prev('.slider').length == 1) {
				prev = current.prev('.slider');
			} else {
				prev = current.parent().children('.slider').last();
			}

			current.removeClass('active-slider');
			prev.addClass('active-slider animated fadeIn');

		$('.slider-number').text('Slide ' + prev.attr('data-slide-number') + ' of 3');

			}

		}

		initialX = null;
		initialY = null;

		e.preventDefault();

	};





});









